"use client";

import { useEffect, useState } from "react";

type Auction = {
  id: number;
  title: string;
  type: string;
  location: string;
  start_at: string;
  cover_image?: string;
  highlight_position?: number;
};

export default function Home() {
  const [auctions, setAuctions] = useState<Auction[]>([]);

  useEffect(() => {
    fetch("https://api.nexbid.pro/auctions/highlight")
      .then(res => res.json())
      .then(data => setAuctions(data));
  }, []);

  return (
    <div style={{ padding: 40 }}>
      <h1>Leilões em Destaque</h1>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gap: 20,
        marginTop: 20
      }}>
        {auctions
          .sort((a: any, b: any) => (a.highlight_position || 0) - (b.highlight_position || 0))
          .map(a => (
            <div
              key={a.id}
              style={{
                border: "1px solid #ccc",
                borderRadius: 8,
                overflow: "hidden",
                cursor: "pointer"
              }}
              onClick={() => window.location.href = `/auction/${a.id}`}
            >

              {a.cover_image && (
                <img
                  src={a.cover_image}
                  style={{ width: "100%", height: 200, objectFit: "cover" }}
                />
              )}

              <div style={{ padding: 15 }}>

                <p style={{ fontWeight: "bold" }}>
                  Destaque #{a.highlight_position}
                </p>

                <h3>{a.title}</h3>
                <p>{a.type}</p>
                <p>{a.location}</p>
                <p>{new Date(a.start_at).toLocaleString()}</p>

              </div>
            </div>
          ))}
      </div>
    </div>
  );
}